import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/theme/index.less'

import 'element-plus/es/components/message/style/css'

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs-plugin-utc'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault('Asia/Shanghai')

document.title = '蜃楼'

const app = createApp(App)
app.provide('store', store).use(router).mount('#app')
app.config.devtools = process.env.NODE_ENV === 'development'
app.config.performance = process.env.NODE_ENV === 'development'
app.config.productionTip = process.env.NODE_ENV === 'development'

